/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  HanaiBase,
  HanaiBaseInterface,
} from "../../../contracts/hanai/HanaiBase";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonLocker",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByLocker",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lockers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum HanaiBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "updateAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "locker",
        type: "address",
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    name: "updateLocker",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type HanaiBaseConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HanaiBaseConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HanaiBase__factory extends ContractFactory {
  constructor(...args: HanaiBaseConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HanaiBase> {
    return super.deploy(
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<HanaiBase>;
  }
  override getDeployTransaction(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(admin, royaltyAddress, overrides || {});
  }
  override attach(address: string): HanaiBase {
    return super.attach(address) as HanaiBase;
  }
  override connect(signer: Signer): HanaiBase__factory {
    return super.connect(signer) as HanaiBase__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HanaiBaseInterface {
    return new utils.Interface(_abi) as HanaiBaseInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HanaiBase {
    return new Contract(address, _abi, signerOrProvider) as HanaiBase;
  }
}
